import React from "react";

/**
 * Capittance brand mark.
 * Wraps the uploaded composite logo (dark navy · gold C · teal bars ·
 * "CAPITTANCE HARMONIZER" wordmark) in a navy chip so it reads on light
 * and dark backgrounds alike.
 *
 * Variants:
 *   variant="wordmark" (default) — mark + wordmark ~ 180×36 (nav headers)
 *   variant="mark"                — icon only, square-ish (favicons, tight)
 */
export default function Logo({ variant = "wordmark", height = 34, className = "", ...rest }) {
  const isMark = variant === "mark";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-sm shadow-sm ${className}`}
      style={{
        background: "#0B1533",
        height: height + 8,
        padding: isMark ? 4 : "4px 10px",
      }}
      {...rest}
    >
      <picture>
        <source srcSet="/capittance-logo.webp" type="image/webp" />
        <img
          src="/capittance-logo.png"
          alt="Capittance Harmonizer"
          width={800}
          height={378}
          decoding="async"
          loading="eager"
          fetchPriority="high"
          style={{
            height,
            width: "auto",
            objectFit: "contain",
            objectPosition: isMark ? "left center" : "center",
            maxWidth: isMark ? height : "unset",
          }}
          draggable={false}
        />
      </picture>
    </span>
  );
}
